/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SectionRolesUpdateRequest
 */
export interface SectionRolesUpdateRequest {
    /**
     * 
     * @type {Array<any>}
     * @memberof SectionRolesUpdateRequest
     */
    roleIds?: Array<any> | null;
}

/**
 * Check if a given object implements the SectionRolesUpdateRequest interface.
 */
export function instanceOfSectionRolesUpdateRequest(value: object): value is SectionRolesUpdateRequest {
    return true;
}

export function SectionRolesUpdateRequestFromJSON(json: any): SectionRolesUpdateRequest {
    return SectionRolesUpdateRequestFromJSONTyped(json, false);
}

export function SectionRolesUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionRolesUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'roleIds': json['roleIds'] === undefined ? undefined : json['roleIds'] === null ? null : json['roleIds'],
    };
}

export function SectionRolesUpdateRequestToJSON(json: any): SectionRolesUpdateRequest {
    return SectionRolesUpdateRequestToJSONTyped(json, false);
}

export function SectionRolesUpdateRequestToJSONTyped(value?: SectionRolesUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roleIds': value['roleIds'],
    };
}

